module.exports = __webpack_public_path__ + "static/annual-report-2014-15-9e8eb388d2c121157107e9162fe9219c.pdf";